export default "__VITE_ASSET__FI4xoDYW__"